// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZT06","questions":"styles_questions__3sGFs","footer":"styles_footer__E9hRS"};